<template>
    <vx-card title="Редактировать попап" id="loader">

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.title"
                        :danger="!!errors.title"
                        :danger-text="errors.title"
                        autocomplete="off"
                        label="Название"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <wysiwyg v-model="item.text" ref="editor" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.redirectUrl"
                        :danger="!!errors.redirectUrl"
                        :danger-text="errors.redirectUrl"
                        autocomplete="off"
                        label="Ссылка для редиректа"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Язык </label>
                    <v-select
                        :options="dicts.languages"
                        placeholder="Выберите язык"
                        class="w-full"
                        label="description"
                        v-model="item.languageId"
                        v-bind:class="{ 'v-select-error': !!errors.languageId }"
                        :reduce="a => a.id"
                    ></v-select>
                    <div v-if="errors.languageId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.languageId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Статус </label>
                    <v-select
                        :options="dicts.statuses"
                        placeholder="Выберите статус"
                        class="w-full"
                        label="name"
                        v-model="item.statusId"
                        v-bind:class="{ 'v-select-error': !!errors.statusId }"
                        :reduce="a => a.id"
                    ></v-select>
                    <div v-if="errors.statusId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.statusId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled"> Сохранить </vs-button>
                <vs-button class="mt-5 mr-2" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
            </div>
        </div>
    </vx-card>
</template>


<script>
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

import "vue-wysiwyg/dist/vueWysiwyg.css";

export default {
    name: 'cabinet-popup-edit',
    props: ['id'],
    data() {
        return {
            item: {
                title: '',
                text: '',
                languageId: '',
                statusId: '',
                redirectUrl: ''
            },
            form: {},
            dicts: {
                languages: [],
                statuses: []
            },
            errors: {
                title: '',
                text: '',
                languageId: '',
                statusId: '',
                redirectUrl: ''
            }
        };
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([
                    this.axios.get('cabinet-popup/' + this.id),
                    this.axios.get('cabinet-popup/dicts')
                ])
                .then(
                    axios.spread((item, dicts) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.dicts.languages = dicts.data.languages;
                        this.dicts.statuses = dicts.data.statuses;
                        this.item = item.data;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки попапа.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.item, { 
                id: this.id, 
                title: this.item.title,
                text: this.item.text,
                languageId: this.item.languageId,
                statusId: this.item.statusId,
                redirectUrl: this.item.redirectUrl
            });

            this.$axios({
                method: 'PUT',
                url: 'cabinet-popup/' + this.id,
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно изменена",
                        text: "Попап успешно изменен",
                        color: "success",
                    });
                    this.$router.push('/cabinet-popups');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors) {
                        if (err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger'
                            });
                        } else {
                            Object.entries(err.data.errors).forEach(entry => {
                                const [key, value] = entry;
                                console.log(key, value);
                                this.errors[key] = value && value.length > 0 ? value[0] : '';
                            });
                        }
                    }

                    this.$forceUpdate();

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при изменении попапа!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/cabinet-popups');
        },
        editorFix() {
            const editorImageBtns = document.querySelectorAll('.vw-btn-image');
            const editorContents = document.querySelectorAll('.editr--content');
            if (editorImageBtns && editorImageBtns.length > 0 &&
                editorContents && editorContents.length > 0
            ) {
                const editorImageBtn = editorImageBtns[0];
                const editorContent = editorContents[0];
                editorImageBtn.addEventListener('click', function(e) {
                    editorContent.focus()
                }.bind(this))
            }
        }
    },
    updated: function(){
        var ref = this;
        this.$nextTick(function () {
            if(typeof ref.$refs.editor != 'undefined'){
                this.editorFix();
            }
        })
    },
    mounted() {
        this.loadData();
    },
    watch: {
    },
};
</script>

<style scoped>
.hr-line-row{
  display: flex;
  align-items: center
}
.hr-line{
  /* border-bottom: 2px solid red; */
  flex: 1;
}
.hr-span {
    margin-right: 15px;
    font-weight: bold;
}
</style>